import { useQuery } from '@tanstack/react-query'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { QueryOptions } from 'models/general'
import { IInvoice } from 'models/invoices.models'
import useDialog from 'hooks/Shared/useDialog'
import useLoadingAdditionalInformation from 'hooks/Shared/useLoadingAdditionalInformation'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { downloadFileFromData } from 'lib/helpers/utilities'
import { getCfdiCancelNotice } from 'services/Invoices/invoices.services'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'

const useDownloadCancelNoticeFile = (
  workspaceId: number,
  invoice?: IInvoice,
  options: QueryOptions<string> = {}
) => {
  const { onSuccess, onError, noDialog } = options

  const dialog = useDialog()
  const showAdditionalInformationLoading = useLoadingAdditionalInformation()

  const query = useQuery<string>(
    ['download-cancel-notice-file-in-base64', workspaceId, invoice],
    () => {
      if (!invoice) throw new Error('CFDI cargado incorrectamente')
      showAdditionalInformationLoading()
      return getCfdiCancelNotice(workspaceId, invoice)
    },
    {
      enabled: false,
      onSuccess: file => {
        dialog.close()
        onSuccess && onSuccess(file)
        downloadFileFromData(`Acuse de Cancelación.pdf`, file)
      },
      onError: async (error: any) => {
        setTimeout(async () => {
          const op = selectErrorDialog(error)
          if (op?.variant) {
            await dialog[op.variant](op)
            return
          }

          if (!noDialog) {
            const rp = await dialog.dangerAsync({
              title: 'generic.error.title',
              subtitle: 'No se pudo descargar el Acuse de Cancelación.',
              icon: ErrorOutline as TModalIcon,
              primaryButtonText: 'Reintentar',
              secondaryButtonText: 'Cancelar',
            })

            if (rp) {
              query.refetch()
              return
            }
          }

          onError && onError(error)
        }, 600)
      },
    }
  )

  return query
}

export default useDownloadCancelNoticeFile
